/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-01-17",
    versionChannel: "nightly",
    buildDate: "2023-01-17T00:23:16.925Z",
    commitHash: "5878bb0c5d6372758eb50b31bb701497205893ad",
};
